module.exports = __webpack_public_path__ + "assets/img/Rules_btn.d75e4817.png";